import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { encodeDates } from '@kinet-open-network/client/core/api-client';
import { IAddItemPrice } from '@kinet-open-network/shared/data-access/model';
import { plainToInstance } from 'class-transformer';
import { Observable, map } from 'rxjs';
import { ItemPrice } from './item-price.model';
import { ITEM_PRICES_CONFIG } from './item-prices.provider';

@Injectable()
export class ItemPricesService {
  private readonly config = inject(ITEM_PRICES_CONFIG);
  private readonly http = inject(HttpClient);

  private get endpoint(): string {
    return this.config.apiEndpoint;
  }

  getPrices(entityId: string, type?: string): Observable<ItemPrice[]> {
    return this.http
      .get<ItemPrice[]>(`${this.endpoint}/${entityId}/pricelist`, {
        params: type ? { type } : undefined,
      })
      .pipe(map((prices) => plainToInstance(ItemPrice, prices)));
  }

  addPrice(
    entityId: string,
    type: string,
    data: IAddItemPrice,
  ): Observable<ItemPrice[]> {
    return this.http
      .post<
        ItemPrice[]
      >(`${this.endpoint}/${entityId}/pricelist/${type}`, encodeDates(data))
      .pipe(map((prices) => plainToInstance(ItemPrice, prices)));
  }

  editPrice(
    entityId: string,
    type: string,
    priceId: string,
    data: IAddItemPrice,
  ): Observable<ItemPrice[]> {
    return this.http
      .put<
        ItemPrice[]
      >(`${this.endpoint}/${entityId}/pricelist/${type}/${priceId}`, encodeDates(data))
      .pipe(map((prices) => plainToInstance(ItemPrice, prices)));
  }

  removePrice(
    entityId: string,
    type: string,
    priceId: string,
  ): Observable<ItemPrice[]> {
    return this.http
      .delete<
        ItemPrice[]
      >(`${this.endpoint}/${entityId}/pricelist/${type}/${priceId}`)
      .pipe(map((prices) => plainToInstance(ItemPrice, prices)));
  }
}
